import React, {useState} from "react";
import {View, TouchableOpacity} from "react-native";
import {useDispatch, useSelector} from "react-redux";
import {getTranslation} from "../../helpers/getTranslation";
import PtText from "../core/pt-text/pt-text";
import PtIcon from "../core/pt-icon/pt-icon";
import {getTranslationsFromApi, setCurrentLanguage} from "../../actions/translationsActions";
import styles from "./pt-language-selector-styles";

const getLabels = (props:any) => {
  return {
    languageLabel : props.languageLabel || getTranslation('language.selector.label') || 'Current language',
    noAuthText : props.noAuthText || getTranslation('langauge.selector.no.auth.text') || 'Feature is not available until login',
  }
}

const renderPickerHeader = (toggleDetails:any, languageLabel:string, currentLanguage:string, detailsVisible:boolean) => {
  return (
    <View>
      <TouchableOpacity onPress={() => toggleDetails()}>
        <View style={styles.langSelectorHeaderWrapper}>
          <PtText style={styles.langSelectorHeaderText}>{languageLabel}: {currentLanguage.toUpperCase()}</PtText>
          {detailsVisible ?
            <PtIcon iconName={'down'}/>
            :
            <PtIcon iconName={'forward-right'} />
          }
        </View>
      </TouchableOpacity>
    </View>
  )
};

const renderPickerDetails = (
    labels:any, detailsVisible:boolean, availableLanguages:any, chooseLanguage:any, currentLanguage:string, isAuthenticated:boolean
  ) => {

  const disabledStyleItem = isAuthenticated ? null : styles.langSelectorItemDisabled;
  const disabledStyleItemText = isAuthenticated ? null : styles.itemTextDisabled;

  return (
    detailsVisible ?
        <View style={styles.langSelectorDetailsContainer}>
          {availableLanguages.map((lang:any, idx:number) => (
            <TouchableOpacity onPress={() => chooseLanguage(lang.code)} key={`langSelector_${idx}`}>
              <View style={[styles.langSelectorSelectItem, lang.code === currentLanguage ? styles.langSelectorItemActive : {}, disabledStyleItem]}>
                <PtText style={[styles.langSelectorItemName, disabledStyleItemText]}>{lang.name}</PtText>
                <PtText style={[styles.langSelectorItemCode, disabledStyleItemText]}>{lang.code.toUpperCase()}</PtText>
              </View>
            </TouchableOpacity>
          ))}
          {!isAuthenticated ?
            <PtText style={styles.noAuthText}>{labels.noAuthText}</PtText>
            : null
          }
        </View>
        : null
  )
}

export default function PtLanguageSelector(props:any) {

  const labels = getLabels(props);

  const [detailsVisible, setDetailsVisible] = useState(false);

  const toggleDetails = () => {
    setDetailsVisible(!detailsVisible);
  };

  /** since we're not using translation service yet (all translations are available on init)
   * we don't need to check if user is authenticated
   * TODO: once the translations service is in place, replace const isAuthenticated = true with line below
   * const isAuthenticated: boolean = useSelector((state:any) => state.authReducer.isAuthenticated);
   */
  const isAuthenticated = true;


  const translationsState = useSelector((state: any) => state.translationsReducer);
  const availableLanguages = translationsState.availableLanguages;
  const collectedLanguages = useSelector((state:any) => state.translationsReducer.collectedLanguages);
  const currentLanguage = useSelector((state:any) => state.translationsReducer.currentLanguage);
  const currentTranslations = translationsState.translations;

  console.log('available Langs = ', currentLanguage);

  const dispatch = useDispatch();
  const chooseLanguage = (langCode:string) => {
    if(collectedLanguages.includes(langCode)) {
      dispatch(setCurrentLanguage(langCode));
    } else {
      if(isAuthenticated) {
        getTranslationsFromApi(dispatch, langCode, currentTranslations);
      }
    }
    toggleDetails();
  };

  return (
    <View style={styles.langSelectorContainer}>
      {renderPickerHeader(toggleDetails, labels.languageLabel, currentLanguage, detailsVisible)}
      {renderPickerDetails(labels, detailsVisible, availableLanguages, chooseLanguage, currentLanguage, isAuthenticated)}
    </View>
  )
}
